import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    list: {
        url: `${customerApi}/api/custom_fields`,
        type: 'GET',
    },
    create: {
        url: `${customerApi}/api/custom_fields`,
        type: 'POST',
    },
    update: {
        url: `${customerApi}/api/custom_fields/{id}`,
        type: 'PUT',
    },
    remove: {
        url: `${customerApi}/api/custom_fields/{id}`,
        type: 'DELETE',
    },
    detail: {
        url: `${customerApi}/api/custom_fields/{id}`,
        type: 'GET',
    },
    swap: {
        url: `${customerApi}/api/custom_fields/swap`,
        type: 'POST',
    },
}
